import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Checkbox,
} from "antd-mobile-v2";
import React, { Component } from "react";
import { createForm } from "rc-form";
import "./index.less";
import UserLogin from "./userLogin";
import MessLogin from "./messLogin";
import secsstion from "../../api/service/secsstion";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import allUrl from "../../api/allUrl";
const Item = List.Item;
const tabs = [{ title: "账号登录" }];
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isbtn: true,
      orgName: "",
    };
    let redRect = this.getQuery("redirect");
    if (redRect) {
      console.log(redRect, "这里面是有东西的");
      if (redRect.redirect == "guide") {
        this.props.history.push("/guide");
      }
      if (redRect.redirect == "matrix") {
        this.props.history.push("/matrix");
      }
    }
  }
  componentDidMount() {
    let num = secsstion.get("token");
    if (num) {
      this.props.history.push("/home");
    }
    let getQueryCode = this.getQuery("orgCode")
    const orgCode=getQueryCode ? getQueryCode.orgCode:(secsstion.get("qiOrgCode")|| "10050001")
    secsstion.set(
      "qiOrgCode",orgCode
    );

    this.getLetterListData();
  }
  //获取各地网上信访数据
  getLetterListData = () => {
    get(allUrl.register.getLetterListData, {
      //  assessType: "",
    }).then((res) => {
      if (res.success === true && res.code == 200) {
        try {
          let data = JSON.parse(res.data);
          console.log(data, "企业机构数据");
          let titleName = this.fiterTitleName(data);
          secsstion.set("qiYName", titleName);
          this.setState({ orgName: titleName });
        } catch (error) {}
      } else {
      }
    });
  };
  fiterTitleName = (data) => {
    let getQueryCode = secsstion.get("qiOrgCode");
    let tileName = "中国石化";
    if (getQueryCode == undefined) return tileName;
    let newData = data.filter((item) => {
      return item.orgCode == getQueryCode;
    });
    if (newData.length > 0) {
      tileName = newData[0].abbreviation;
    }
    return tileName;
  };
  getQuery = (pam) => {
    let obj = {};
    let search = window.location.href.split("?")[1];
    let pamn = search ? search.split("&") : [];
    pamn.length &&
      pamn.forEach((item, index) => {
        let params = item.split("=");
        if (params[0] == pam) {
          obj[params[0]] = params[1];
        }
      });
    return obj[pam] ? obj : null;
  };
  render() {
    const { isbtn } = this.state;
    return (
      <div className="logn-cont">
        <div className="login-top"></div>
        <div className="login-logo"></div>
        <div className="login-text">{this.state.orgName}网上信访</div>
        <div className="login-wrap">
          <Modal
            visible={this.state.visible}
            transparent
            maskClosable={false}
            title="注册须知"
            footer={[]}
            closable={true}
            onClose={() => {
              this.setState({
                visible: false,
              });
            }}
          >
            <div className="modal-center">
              1、请实名注册，真实准确填写个人信息。
              <br />
              2、如代他人网上信访，请使用代理人信息进行注册.
              <br />
              3、一个有效证件只能注册一次。
              <br />
              <div className="modal-foter">
                <Checkbox
                  style={{ fontSize: "0.13rem", color: "#128EE9" }}
                  onChange={(e) => {
                    this.setState({ isbtn: !e.target.checked });
                  }}
                >
                  &nbsp;&nbsp;我已阅读并同意。
                </Checkbox>
                <div className="foter-btn">
                  <Button
                    type="primary"
                    disabled={isbtn}
                    inline
                    size="small"
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/register",
                        state: {
                          type: "reg",
                        },
                      });
                    }}
                  >
                    同意
                  </Button>
                  <Button
                    type="primary"
                    inline
                    size="small"
                    onClick={() => {
                      this.setState({
                        visible: false,
                      });
                    }}
                  >
                    不同意
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
          <div>
            <Tabs
              tabs={tabs}
              initialPage={0}
              animated={false}
              useOnPan={false}
              tabBarUnderlineStyle={{ display: "none" }}
            >
              <div
                style={{
                  height: "3.6rem",
                  backgroundColor: "#fff",
                }}
              >
                <UserLogin props={this.props} />
              </div>
              <div
                style={{
                  height: "2.8rem",
                  backgroundColor: "#fff",
                }}
              >
                <MessLogin props={this.props} />
              </div>
            </Tabs>
          </div>
          <div
            style={{
              width: "100%",
              padding: "0 0.1rem",
              height: "0.4rem",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              position: "absolute",
              left: "0",
              bottom: "0",
            }}
          >
            <span
              style={{
                color: "#A3A3A3",
                fontSize: "0.15rem",
                textDecoration: "underline",
              }}
              onClick={() => {
                this.setState({
                  visible: true,
                });
              }}
            >
              立即注册
            </span>
            <span
              style={{
                color: "#A3A3A3",
                fontSize: "0.15rem",
                textDecoration: "underline",
              }}
              onClick={() => {
                this.props.history.push({
                  pathname: "/register",
                  state: {
                    type: "reset",
                  },
                });
              }}
            >
              重置账号
            </span>
            <span
              style={{
                color: "#A3A3A3",
                fontSize: "0.15rem",
                textDecoration: "underline",
              }}
              onClick={() => {
                this.props.history.push("/editPaswed");
              }}
            >
              忘记密码
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
